import { Snackbar } from "@material-ui/core";
import { css, cx } from "emotion";
import React from "react";
import NotificationOrderIcon from "../../assets/icons/notification-neworder.png";
import CloseCircleIcon from "../../assets/icons/close-circle.png";
import { createConfirmation } from "react-confirm";
import confirmable from "react-confirm/lib/confirmable";
import NewOrderNotificationSound from "../../assets/audio/order_alert.mp3";

const ToastSnackbar = (props) => {
  const {
    positionV,
    positionH,
    handleClickAction,
    actionLabel,
    withSound,
    looping,
  } = props;
  const [open, setOpen] = React.useState(true);
  const audioRef = React.useRef();

  const position = {
    horizontal: positionH || "right",
    vertical: positionV || "top",
  };

  const play = (play) => {
    if (play && withSound) {
      audioRef.current.loop = looping;
      audioRef.current.src= NewOrderNotificationSound;
      document.querySelector('#toastAudio').play();
    }
  };

  const pause = () => {
    audioRef.current.pause();
  };

  const handleClose = () => {
    pause();
    setOpen(false);
  };

  const onClickAction = () => {
    handleClose();
    handleClickAction();
  };

  React.useEffect(() => {
    play(open);
  }, [open]);

  return (
    <Snackbar
      anchorOrigin={position}
      open={open}
      onClose={handleClose}
      key={new Date()}
    >
      <div
        className={cx(
          css`
            box-shadow: 0px 0px 24px -3px rgba(0, 0, 0, 0.54);
            -moz-box-shadow: 0px 0px 24px -3px rgba(0, 0, 0, 0.54);
            -webkit-box-shadow: 0px 0px 14px -3px rgba(0, 0, 0, 0.54);
          `,
          "rounded-8px p-3 bg-white"
        )}
      >
        <div className="d-flex justify-content-between align-items-center">
          <img
            src={NotificationOrderIcon}
            alt="new order"
            style={{ width: 60, height: 60 }}
          />
          <div className="px-3 mr-4">
            <div className="d-flex justify-content-start align-items-center">
              <p className="font-12 text-primary mb-0">
                <span className="font-14 font-bold text-primary">
                  New Order
                </span>
                <br />
                Hi, you got a new order.
              </p>
            </div>
          </div>
          <div className="align-self-start">
            <span className="cursor-pointer" onClick={() => handleClose()}>
              <img
                src={CloseCircleIcon}
                alt="close"
                style={{ width: 24, height: 24 }}
              />
            </span>
          </div>
        </div>
        <div>
          <button
            type="button"
            onClick={onClickAction}
            className={cx(
              css`
                border-radius: 6px !important;
                background-color: #9acafc !important;
                color: #007bff !important;
              `,
              "btn btn-block font-bold font-12 mt-2"
            )}
          >
            {actionLabel || "Action"}
          </button>
        </div>
        <audio id="toastAudio" ref={audioRef}></audio>
      </div>
    </Snackbar>
  );
};

export function ToastNotification(
  positionV,
  positionH,
  actionLabel,
  handleClickAction,
  withSound,
  looping,
  options = {}
) {
  return createConfirmation(confirmable(ToastSnackbar))({
    positionV,
    positionH,
    actionLabel,
    handleClickAction,
    withSound,
    looping,
    ...options,
  });
}
